import React from 'react';
import { Image, Text, View, StyleSheet } from '@react-pdf/renderer';
import { colors, typography, spacing } from './styles/theme';
import { SectionTitle } from './components';

const styles = StyleSheet.create({
  container: {
    paddingBottom: spacing.lg,
  },
  chartsRow: {
    flexDirection: 'row',
    marginTop: spacing.md,
    justifyContent: 'space-between',
  },
  chartColumn: {
    width: '48%',
  },
  chartWrapper: {
    borderWidth: 1,
    borderColor: colors.border.light,
    borderStyle: 'solid',
    padding: spacing.md,
    backgroundColor: colors.background.white,
  },
  chartTitle: {
    ...typography.subsection,
    marginBottom: spacing.md,
    textAlign: 'center',
  },
  chartImageContainer: {
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
  // Aspect ratio ~1.5:1 to match the captured chart (400x300 -> 1.33:1)
  // We'll use a fixed height that maintains the proportion
  chartImage: {
    width: 200,
    height: 150,
  },
  chartDescription: {
    ...typography.caption,
    marginTop: spacing.md,
    textAlign: 'center',
  },
});

const Page5 = ({ c7 = null, c8 = null }) => {
  if (!c7 && !c8) return null;

  return (
    <View style={styles.container} break>
      <SectionTitle
        title="Perfil Tecnológico"
        subtitle="Análisis de dispositivos y software utilizados por la audiencia"
      />

      <View style={styles.chartsRow}>
        {/* Browser Distribution */}
        {c7 && (
          <View style={styles.chartColumn}>
            <View style={styles.chartWrapper}>
              <Text style={styles.chartTitle}>Navegadores Web</Text>
              <View style={styles.chartImageContainer}>
                <Image style={styles.chartImage} src={c7} />
              </View>
              <Text style={styles.chartDescription}>
                Distribución de navegadores utilizados por los espectadores para
                acceder a la transmisión.
              </Text>
            </View>
          </View>
        )}

        {/* OS Distribution */}
        {c8 && (
          <View style={styles.chartColumn}>
            <View style={styles.chartWrapper}>
              <Text style={styles.chartTitle}>Sistemas Operativos</Text>
              <View style={styles.chartImageContainer}>
                <Image style={styles.chartImage} src={c8} />
              </View>
              <Text style={styles.chartDescription}>
                Distribución de sistemas operativos de los dispositivos
                utilizados para acceder a la transmisión.
              </Text>
            </View>
          </View>
        )}
      </View>
    </View>
  );
};

export default Page5;
